<!-- Table Section -->
<div class="p95-utilization-list relative overflow-hidden">
      <table
        mat-table
        [dataSource]="pagedRecords$()"
        matSort
        matSortDisableClear
        matSortActive="heat"
        matSortDirection="desc"
        (matSortChange)="onMatSortChange($event)"
        class="w-full text-sm"
      >
    <!-- Heat Column (sorted by weighted max/min hotness formula) -->
    <ng-container matColumnDef="heat">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header="heat"
        matTooltip="Sorted by hotness: max(In %, Out %) + 0.5 * min(In %, Out %)"
        matTooltipPosition="right"
        class="heat-header"
      >
        <mat-icon class="heat-icon !text-[20px]">whatshot</mat-icon>
      </th>
      <td mat-cell *matCellDef="let element" class="heat-cell"></td>
    </ng-container>

    <!-- Customer Location Column -->
    <ng-container matColumnDef="name_customer_location">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name_customer_location">
        <span class="font-semibold">Location</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.name_customer_location }}
      </td>
    </ng-container>

    <!-- Connection ID Column -->
    <ng-container matColumnDef="dim_connection_id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dim_connection_id">
        <span class="font-semibold">Link</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.dim_connection_id }}
      </td>
    </ng-container>

    <!-- P95 RX Utilization Column -->
    <ng-container matColumnDef="p95_utilization_rx_pct">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="p95_utilization_rx_pct">
        <span class="font-semibold">In %</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span
          [class]="'utilization-pill ' + getHeatLevelClass(element.p95_utilization_rx_pct, maxUtilization$().rx)"
        >
          {{ formatPercentage(element.p95_utilization_rx_pct) }}
        </span>
      </td>
    </ng-container>

    <!-- P95 TX Utilization Column -->
    <ng-container matColumnDef="p95_utilization_tx_pct">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="p95_utilization_tx_pct">
        <span class="font-semibold">Out %</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span
          [class]="'utilization-pill ' + getHeatLevelClass(element.p95_utilization_tx_pct, maxUtilization$().tx)"
        >
          {{ formatPercentage(element.p95_utilization_tx_pct) }}
        </span>
      </td>
    </ng-container>

    <!-- Provisioned RX Speed Column -->
    <ng-container matColumnDef="provisioned_speed_rx_mbps">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="provisioned_speed_rx_mbps">
        <span class="font-semibold">Speed In</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ formatSpeed(element.provisioned_speed_rx_mbps) }}
      </td>
    </ng-container>

    <!-- Provisioned TX Speed Column -->
    <ng-container matColumnDef="provisioned_speed_tx_mbps">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="provisioned_speed_tx_mbps">
        <span class="font-semibold">Speed Out</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ formatSpeed(element.provisioned_speed_tx_mbps) }}
      </td>
    </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="columns"
        class="hidden md:table-row"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: columns"
        class="border-b border-gray-100 hover:bg-gray-50"
      ></tr>
      </table>

      <!-- Loading Overlay -->
      @if (observations$.loading$()) {
        <div class="absolute inset-0 z-20 bg-white/75">
          <!-- Progress Bar -->
          <div class="absolute left-0 right-0 top-0 z-30 md:top-[35px]">
            <mat-progress-bar mode="indeterminate" class="!h-1"></mat-progress-bar>
          </div>
        </div>
      }

      <!-- No Data Message -->
      @if (filteredRecords$().length === 0) {
        <div class="p-8 !text-center text-gray-600">
          <span class="material-icons mb-2 !h-10 !w-10 !text-4xl">inbox</span>
          <p>No utilization records found</p>
          <p class="text-sm">Try adjusting your filters or search criteria</p>
        </div>
      }
</div>
